var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.7 186.8V218H188v42.4h36.6v108.9h43.8V260.5H305l5.5-42.5h-42v-27c0-12.3 3.4-20.7 21-20.7H312v-38c-10.9-1.2-21.8-1.7-32.7-1.7-32.5.1-54.6 19.8-54.6 56.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0C111.9 0 0 111.9 0 250s111.9 250 250 250 250-111.9 250-250S388.1 0 250 0zm0 479.1C123.7 479.1 20.9 376.3 20.9 250S123.7 20.9 250 20.9 479.1 123.7 479.1 250 376.3 479.1 250 479.1z"
  })));
}
export default SvgIconFacebook;